module.exports = __webpack_public_path__ + "img/template-active.dceda02d.svg";